var components
try {
  components = {
    uParse: function () {
      return import(
        /* webpackChunkName: "components/u-parse/u-parse" */ "@/components/u-parse/u-parse.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.style(600)
  var m1 =
    !_vm.product.priceTag &&
    (_vm.isVip
      ? _vm.selectedSku.vipPrice
        ? _vm.selectedSku.vipPrice
        : _vm.product.vipPrice
      : _vm.selectedSku.price
      ? _vm.selectedSku.price
      : _vm.product.price) <
      (_vm.selectedSku.price
        ? _vm.selectedSku.originalPrice
        : _vm.product.originalPrice)
      ? parseInt(
          ((_vm.isVip
            ? _vm.selectedSku.vipPrice
              ? _vm.selectedSku.vipPrice
              : _vm.product.vipPrice
            : _vm.selectedSku.price
            ? _vm.selectedSku.price
            : _vm.product.price) /
            (_vm.selectedSku.originalPrice
              ? _vm.selectedSku.originalPrice
              : _vm.product.originalPrice)) *
            100
        )
      : null
  var g0 = _vm.couponList.length
  var g1 = _vm.product.appraisePage && _vm.product.appraisePage.items.length > 0
  var m2 = _vm.product.img ? _vm.style(200) : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        g0: g0,
        g1: g1,
        m2: m2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }